import Vue from 'vue';
import { Servicelayer } from '@glittr/frontend-core/src/plugins/servicelayer';
import AppSystemWebApisApi from '../generated/api/AppSystemWebApis';

export default (service: Servicelayer) => ({
  ...AppSystemWebApisApi(service),

  // Add custom calls here

});
